"use client";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Autocomplete } from "@base-ui/react/autocomplete";
import FilterChipBar from "../Autocomplete/FilterChipBar/FilterChipBar.js";
import { Span } from "../Text/index.js";
import { BaseAutocompleteItem } from "./BaseAutocompleteItem.js";
function ItemListContent({ filterChipData, handleFilterChipClick, selectedFilterChipData, listSlot, emptySlot, groupLabelSlot, autocompleteItems, isGrouped, renderEmpty, handleItemSelect }) {
    const hasFilterChips = filterChipData.length > 0 && 'function' == typeof handleFilterChipClick;
    const itemCount = isGrouped ? autocompleteItems.reduce((acc, g)=>acc + g.items.length, 0) : autocompleteItems.length;
    if (0 === itemCount && renderEmpty) return /*#__PURE__*/ jsx(Autocomplete.Empty, {
        className: emptySlot(),
        children: renderEmpty()
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            hasFilterChips && /*#__PURE__*/ jsx(FilterChipBar, {
                filterChipData: filterChipData,
                handleFilterChipClick: handleFilterChipClick,
                selectedFilterChipData: selectedFilterChipData
            }),
            isGrouped && /*#__PURE__*/ jsx(Autocomplete.List, {
                className: listSlot(),
                children: autocompleteItems.map((group)=>/*#__PURE__*/ jsxs(Autocomplete.Group, {
                        items: group.items,
                        children: [
                            /*#__PURE__*/ jsx(Autocomplete.GroupLabel, {
                                className: groupLabelSlot(),
                                children: /*#__PURE__*/ jsx(Span, {
                                    textStyle: "body3",
                                    color: "primary-13",
                                    children: group.label
                                })
                            }),
                            /*#__PURE__*/ jsx(Autocomplete.Collection, {
                                children: (item, itemIndex)=>/*#__PURE__*/ jsx(BaseAutocompleteItem, {
                                        value: item,
                                        firstLine: item.displayLine1 ?? item.itemName,
                                        secondLine: item.displayLine2,
                                        itemType: item.type,
                                        iconName: item.iconName,
                                        handleItemSelect: handleItemSelect
                                    }, `${item.itemName}-${itemIndex}`)
                            })
                        ]
                    }, `group-${group.label}`))
            }),
            !isGrouped && /*#__PURE__*/ jsx(Autocomplete.List, {
                className: listSlot(),
                children: autocompleteItems.map((item, index)=>/*#__PURE__*/ jsx(BaseAutocompleteItem, {
                        value: item,
                        firstLine: item.displayLine1 ?? item.itemName,
                        secondLine: item.displayLine2,
                        itemType: item.type,
                        iconName: item.iconName,
                        handleItemSelect: handleItemSelect
                    }, `${item.itemName}-${index}`))
            })
        ]
    });
}
export { ItemListContent };
